import type { Theme } from '@mui/material';

export const styles = {
  reportSnackbar: {
    '&.MuiSnackbar-root': {
      marginTop: 0,
    },
  },

  reportSnackbarContent: (theme: Theme) => ({
    bgcolor: theme.colors.white,
    color: theme.colors.black,
    flexWrap: 'nowrap',

    '&.MuiPaper-root': {
      padding: '1rem 1.5rem',
    },

    '> *': {
      p: 0,
    },
  }),

  reportSnackbarIcon: (theme: Theme) => ({
    borderRadius: '50%',
    bgcolor: theme.colors.error[500],
    width: '2.5rem',
    height: '2.5rem',
    color: theme.colors.white,
    justifyContent: 'center',
    flexDirection: 'column',

    svg: {
      margin: 'auto',
    },
  }),

  reportSnackbarText: {
    direction: 'column',
    justifyContent: 'center',
    px: 2.5,
    maxWidth: '22rem',
  },
};
